const ACCOUNTS = [
  {account_id: '00D41000001PZOlEAO', org_name: "Customer Success"},
  {account_id: "00D1a000000He6zEAC", org_name: "andrewdev", upgraded: true},
  {account_id: "00Do0000000dbR2EAI", org_name: "andrew@dialsource.com.unmanaged", upgraded: true},
  {account_id: "cf3d5248-850c-46cb-8e3b-4bf2a1222307", org_name: "San Francisco 49ers Sandbox"},
  {account_id: "00D36000000sK1iEAE", org_name: "DialSource Implementation"},
  {account_id: "00Di0000000KrsNEAS", org_name: "Stanford"},
  {account_id: "00D36000000q6UYEAY", org_name: "Albert Demo"},
  {account_id: "00D61000000IgsGEAS", org_name: "Daniel Sulaiman Demo"},
  {account_id: "00D400000009SdlEAE", org_name: "DialSource Production"},
  {account_id: "00D36000000J4FsEAK", org_name: "DialSource V3 Development"},
  {account_id: "00D61000000H2VhEAK", org_name: "Kevin Blessum Demo Org"},
  {account_id: "00D30000001I0WsEAK", org_name: "Underground Elephant"},
  {account_id: "00D36000000vrluEAA", org_name: "raysu814@outlook.com"},
  {account_id: "00Dd0000000e2UWEAY", org_name: "IQ Hunt"},
  {account_id: "00D60000000Kda5EAC", org_name: "i-sight"},
  {account_id: "00D61000000KXhJEAW", org_name: "2awesome"},
  {account_id: "00D36000000a3xiEAA", org_name: "Tyree Dev Org"},
  {account_id: "00D30000000pgfeEAA", org_name: "Cirruspath Inc."},
  {account_id: "1ee147a0-4020-4e66-9333-6a9a32e43939", org_name: "San Francisco 49ers Production"},
  {account_id: "00Do0000000dY6bEAE", org_name: "Josh Demo Org"},
  {account_id: "00DF00000006aJYMAY", org_name: "Pike Creek Mortgage Services"},
  {account_id: "00DA0000000gbsLMAQ", org_name: "Solution Tree"},
  {account_id: "00Dd0000000huk6EAA", org_name: "Tactile"},
  {account_id: "00DU0000000J7ICMA0", org_name: "SalesStaff LLC"},
  {account_id: "00D61000000Jpj6EAC", org_name: "OneTrust Production Org"},
  {account_id: "00Di0000000bBuKEAU", org_name: "360 Risk Partners"},
  {account_id: "00Do0000000Ik9sEAC", org_name: "Intero Production"},
  {account_id: "00D50000000bQ9zEAE", org_name: "Jitesh's Dev Org"},
  {account_id: "00D37000000I2llEAC", org_name: "Choice City Health"},
  {account_id: "00D410000006qkcEAA", org_name: "Eric's Dev Org 2"},
  {account_id: "00D60000000JS8CEAW", org_name: "Pivot3 Inc."},
  {account_id: "00D3B0000008dMJUAY", org_name: "Dining Alliance Sandbox"},
  {account_id: "00Dc0000003oak9EAA", org_name: "Ericsbox (DS Sandbox)"},
  {account_id: "00D5C0000008ap7UAA", org_name: "Dining Alliance Sandbox Developer"},
  {account_id: "00D36000000Z513EAC", org_name: "JamesOrg"},
  {account_id: "00D36000000Jmv7EAC", org_name: "Quans Dev Org"},
  {account_id: "00D41000000GIJOEA4", org_name: "Pindrop"},
  {account_id: "00D700000008AVJEA2", org_name: "Market Technologies Production"},
  {account_id: "00D50000000ZyEYEA0", org_name: "Tyree's Dev Org"},
  {account_id: "00D61000000ePGSEA2", org_name: "UNR (Kevin)"},
  {account_id: "00D41000000dud5EAA", org_name: "Stephen Leopold Dev Org"},
  {account_id: "00Dq00000000QBAEA2", org_name: "Valley Force Sandbox"},
  {account_id: "00D61000000Y2YCEA0", org_name: "Vagaro, Inc."},
  {account_id: "00D36000001GH07EAG", org_name: "Sacramento Kings Production"},
  {account_id: "00D300000000NMUEA2", org_name: "AppNeta"},
  {account_id: "00D41000000dyMYEAY", org_name: "DK & Associates"},
  {account_id: "00D5B000000D7gSUAS", org_name: "RealtyMogul Sandbox"},
  {account_id: "00De0000005WRZeEAO", org_name: "Zywave Sandbox"},
  {account_id: "00D300000000dTdEAI", org_name: "SS8 Pilot"},
  {account_id: "00D300000000X1pEAE", org_name: "Terra Education"},
];

export default ACCOUNTS;
